export const defaultValues = {
  name: '',
  lastName: '',
  password: '',
  repeatPassword: '',
  photo: { name: null },
};
